import AbstractNetworkStatus from '../all/AbstractNetworkStatus';
import logger from 'src/utils/logger/logger';

class Web0sNetworkStatus extends AbstractNetworkStatus {

  constructor() {
    super();
  }

  isOnline() {
    logger.debug('[NetworkStatus] checking Web0s...');
    return this.onlineByAjax();
  }

}

export default Web0sNetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/web0s/NetworkStatus.js